export enum SubmissionErrors {
    LensIsInReview = `You cannot update the Lens with "In review" status`,
}

export class SubmissionError extends Error {
    constructor(message: SubmissionErrors) {
        super(message);
        this.name = "PreviewValidationError";
    }
}
